/* eslint-disable import/no-anonymous-default-export */
import {
  SET_USER,
  USER_REGISTER,
  OTP_VERIFICATION,
  ADD_GARAGE_DATA,
  UPDATE_GARAGE_DATA,
  ADD_SPARE_PARTS_DATA,
  ADD_CAR_DELEAR_DATA,
  ADD_CAR_RENT_DATA,
  ADD_CAR_SALE_DATA,
  ADD_TAXI_DATA,
  ADD_MEDIA_DATA,
  UPDATE_SPARE_PART_DATA,
  UPDATE_CAR_DEALER_DATA,
  UPDATE_CAR_RENT_DATA,
  GET_CAR_DEALER_LISTING,
  UPDATE_TAXI_DATA,
  GET_GARAGE_FILTER_DATA,
  GET_ONE_GARAGE_LIST,
  FORGOT_PASSWORD,
  UPDATE_PASSWORD,
  GET_GARAGE_CATEGORY,
  GET_GARAGE_CARBRAND,
  GET_SPARE_PART_CATEGORY,
  GET_CAR_DEALER_CAR_LISTING,
  GET_SPARE_PART_LISTING,
  GET_ONE_CARDEALER_LIST,
  GET_ONE_PART_LIST,
  GET_ONE_PART_DETAIL_LIST,
  GET_CAR_WAHS_CATEGORY,
  GET_CAR_WASH_LISTING,
  GET_CAR_INSURANCE_CATEGORY,
  GET_CAR_INSURANCE_LISTING,
  GET_CAR_WASH_DETAIL_LIST,
  GET_CAR_INSURANCE_DETAIL_LIST,
  GET_TAXI_OWNER_ALL_DATA,
  GET_TAXI_OWNER_DETAIL_LIST,
  GET_CATEGORY,
  GET_DRIVING_SCHOOL_LISTING,
  GET_CAR_PROTECTION_LISTING,
  GET_CAR_PROTECTION_DETAIL_LIST,
  GET_AIR_CONDITIONING_LISTING,
  DETAIL_LIST,
  GET_QUICKSERVICES_LISTING,
  GET_cAR_RENT_LISTING,
  GET_cAR_RENT_CAR_LISTING,
  GET_MY_BUSINESS,
  GET_SPARE_PARTS,
  GET_TOWING_OWNER_ALL_DATA,
  GET_ALL_PLANS,
  GET_CAR_SALE_DATA,
  GET_CAR_MODEL_YEAR,
  GET_CAR_CYLINDER,
  GET_CAR_FUEL_TYPE,
  GET_CAR_SEATS,
  GET_CAR_DOORS,
  GET_CAR_COLORS,
  GET_CAR_SAFETY,
  GET_CAR_COMFORT,
  GET_CAR_MODEL,
  GET_CAR_MODELS,
  GET_SAVED_ITEMS_LIST,
  GET_RECENT_VIEWED_CARS_LIST,
  UPDATE_USER_PROFILE,
  GETTING_USER_PROFILE,
  GETTING_USER_CAR_DETAILS,
  USER_GARAGE_AZ_FILTER,
  USER_GARAGE_ZA_FILTER,
  FILTER_GARAGE_LIST_WITH_CATEGORY,
  USER_SPARE_PARTS_AZ_FILTER,
  USER_SPARE_PARTS_ZA_FILTER,
  FILTER_SPARE_PARTS_WITH_CATEGORY,
  GET_TAXI_OWNER_DATA,
  GET_CAR_AGENT_LISTING,
  GET_SINGLE_CAR_TOWRING_DATA,
  GET_DRIVING_SCHHOL_WITH_FILTER,
  GET_CAR_AGENTS_LIST,
  GET_CAR_AGENTS_DETAIL_LIST,
  GETTING_USER_MY_POST,
  MAKE_NEW_PAYMENT,
  GET_GARAGE_SERVICES_DATA,
  GET_CURRENT_PLAN,
  GET_ALL_PACKAGES_HISTORY,
  GET_FILTERED_CAR_DEALER_LISTING,
} from '../Actions/ActionType';

var initialState = {
  carModels: [],
};

const homeReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_REGISTER:
      return {
        ...state,
        registerList: action.payload,
      };
    case GET_TAXI_OWNER_DATA:
      return {
        ...state,
        TaxiOwnerList: action.payload,
      };
    case GET_CAR_AGENT_LISTING:
      return {
        ...state,
        CarAgentsList: action.payload,
      };

    case FORGOT_PASSWORD:
      return {
        ...state,
        ForgotPasswordList: action.payload,
      };
    case UPDATE_PASSWORD:
      return {
        ...state,
        UpdatePasswordList: action.payload,
      };
    case OTP_VERIFICATION:
      return {
        ...state,
        otpVerificationList: action.payload,
      };

    case SET_USER:
      return {
        ...state,
        userData: action.payload,
      };
    case ADD_GARAGE_DATA:
      return {
        ...state,
        AddGarageList: action.payload,
      };
    case UPDATE_GARAGE_DATA:
      return {
        ...state,
        UpdateGarageList: action.payload,
      };
    case GET_GARAGE_FILTER_DATA:
      return {
        ...state,
        GarageFilterList: action.payload,
      };
    case GET_GARAGE_SERVICES_DATA:
      return {
        ...state,
        GarageServices: action.payload,
      };
    case GET_CURRENT_PLAN:
      return {
        ...state,
        currentPlanDetail: action.payload,
      };
    case ADD_SPARE_PARTS_DATA:
      return {
        ...state,
        AddSparePartsList: action.payload,
      };
    case MAKE_NEW_PAYMENT:
      return {
        ...state,
        paymentResponse: action.payload,
      };
    case UPDATE_SPARE_PART_DATA:
      return {
        ...state,
        UpdateSparePartsList: action.payload,
      };
    case GETTING_USER_MY_POST:
      return {
        ...state,
        userMyPostLists: action.payload,
      };

    case ADD_CAR_DELEAR_DATA:
      return {
        ...state,
        AddCarDelearList: action.payload,
      };
    case UPDATE_CAR_DEALER_DATA:
      return {
        ...state,
        UpdateCarDelearList: action.payload,
      };

    case ADD_CAR_RENT_DATA:
      return {
        ...state,
        AddCarRentList: action.payload,
      };
    case UPDATE_CAR_RENT_DATA:
      return {
        ...state,
        UpdateCarRentList: action.payload,
      };

    case ADD_CAR_SALE_DATA:
      return {
        ...state,
        AddCarSaleList: action.payload,
      };

    case ADD_TAXI_DATA:
      return {
        ...state,
        AddTaxiList: action.payload,
      };
    case UPDATE_TAXI_DATA:
      return {
        ...state,
        UpdateTaxiList: action.payload,
      };
    case ADD_MEDIA_DATA:
      return {
        ...state,
        AddMediaList: action.payload,
      };

    case GET_GARAGE_CATEGORY:
      return {
        ...state,
        garageCategoryList: action.payload,
      };
    case GET_GARAGE_CARBRAND:
      return {
        ...state,
        garageCarBrandList: action.payload,
      };
    case GET_CAR_MODEL:
      return {
        ...state,
        CarModels: action.payload,
      };
    case GET_CAR_MODELS:
      return {
        ...state,
        carModels: action.payload,
      };
    case GET_CAR_SAFETY:
      return {
        ...state,
        CarSafety: action.payload,
      };
    case GET_CAR_COMFORT:
      return {
        ...state,
        CarComfort: action.payload,
      };
    case GET_CAR_CYLINDER:
      return {
        ...state,
        CarCylinders: action.payload,
      };
    case GET_CAR_FUEL_TYPE:
      return {
        ...state,
        CarFuelTypes: action.payload,
      };
    case GET_CAR_MODEL_YEAR:
      return {
        ...state,
        CarModelYears: action.payload,
      };
    case GET_CAR_SEATS:
      return {
        ...state,
        CarSeats: action.payload,
      };
    case GET_CAR_DOORS:
      return {
        ...state,
        CarDoors: action.payload,
      };
    case GET_CAR_COLORS:
      return {
        ...state,
        CarColors: action.payload,
      };

    case GET_SPARE_PART_CATEGORY:
      return {
        ...state,
        SparePartCategoryList: action.payload,
      };
    case GET_CAR_DEALER_CAR_LISTING:
      return {
        ...state,
        CarDealerCarList: action.payload,
      };
    case GET_ONE_GARAGE_LIST:
      return {
        ...state,
        OnegarageDetailList: action.payload,
      };

    case GET_SPARE_PART_LISTING:
      return {
        ...state,
        SparePartList: action.payload,
      };

    case GET_CAR_DEALER_LISTING:
      return {
        ...state,
        CarDealertList: action.payload,
      };
    case GET_FILTERED_CAR_DEALER_LISTING:
      return {
        ...state,
        FilteredCarDealertList: action.payload,
      };

    case GET_ONE_CARDEALER_LIST:
      return {
        ...state,
        OneCarDealerDetailList: action.payload,
      };
    case GET_ONE_PART_LIST:
      return {
        ...state,
        OnePartList: action.payload,
      };
    case GET_SINGLE_CAR_TOWRING_DATA:
      return {
        ...state,
        singleCarTowing: action.payload,
      };
    case GET_ONE_PART_DETAIL_LIST:
      return {
        ...state,
        OnePartDetailList: action.payload,
      };
    case GET_CAR_WAHS_CATEGORY:
      return {
        ...state,
        CarWashCategoryList: action.payload,
      };
    case GET_CAR_WASH_LISTING:
      return {
        ...state,
        CarWashAllList: action.payload,
      };
    case GET_CAR_INSURANCE_CATEGORY:
      return {
        ...state,
        CarInsuranceCategoryList: action.payload,
      };
    case GET_CAR_INSURANCE_LISTING:
      return {
        ...state,
        getCarInsuranceAllList: action.payload,
      };
    case GET_CAR_WASH_DETAIL_LIST:
      return {
        ...state,
        getCarWashDetailList: action.payload,
      };
    case GET_CAR_INSURANCE_DETAIL_LIST:
      return {
        ...state,
        getCarInsuranceDetailList: action.payload,
      };
    case GET_TAXI_OWNER_ALL_DATA:
      return {
        ...state,
        getTaxiOwnerList: action.payload,
      };
    case GET_TAXI_OWNER_DETAIL_LIST:
      return {
        ...state,
        getTaxiOwnerDetailList: action.payload,
      };
    case GET_CATEGORY:
      return {
        ...state,
        getCategoryList: action.payload,
      };
    case GET_DRIVING_SCHOOL_LISTING:
      return {
        ...state,
        getDrivingSchoolList: action.payload,
      };
    case GET_DRIVING_SCHHOL_WITH_FILTER:
      return {
        ...state,
        getDrivingSchoolWithFilter: action.payload,
      };
    case GET_CAR_AGENTS_LIST:
      return {
        ...state,
        getCarAgentList: action.payload,
      };
    case GET_CAR_AGENTS_DETAIL_LIST:
      return {
        ...state,
        getCarAgentDetailList: action.payload,
      };
    case GET_CAR_PROTECTION_LISTING:
      return {
        ...state,
        getCarProtectionList: action.payload,
      };
    case GET_CAR_PROTECTION_DETAIL_LIST:
      return {
        ...state,
        getCarProtectionDetailList: action.payload,
      };

    case GET_AIR_CONDITIONING_LISTING:
      return {
        ...state,
        getAirConditioningList: action.payload,
      };
    case DETAIL_LIST:
      return {
        ...state,
        getDetailList: action.payload,
      };
    case GET_QUICKSERVICES_LISTING:
      return {
        ...state,
        getQuickServicesList: action.payload,
      };

    case GET_cAR_RENT_LISTING:
      return {
        ...state,
        getlCarRentList: action.payload,
      };
    case GET_cAR_RENT_CAR_LISTING:
      return {
        ...state,
        getCarRentCarList: action.payload,
      };

    case GET_MY_BUSINESS:
      return {
        ...state,
        getMybusiness: action.payload,
      };
    case GET_ALL_PACKAGES_HISTORY:
      return {
        ...state,
        allPackages: action.payload,
      };
    case GET_SPARE_PARTS:
      return {
        ...state,
        getSpareParts: action.payload,
      };
    case GET_TOWING_OWNER_ALL_DATA:
      return {
        ...state,
        getTowingAllList: action.payload,
      };

    case GET_ALL_PLANS:
      return {
        ...state,
        getAllPlansList: action.payload,
      };
    case GET_CAR_SALE_DATA:
      return {
        ...state,
        carSaleList: action.payload,
      };
    case GET_SAVED_ITEMS_LIST:
      return {
        ...state,
        savedItemsList: action.payload,
      };
    case GET_RECENT_VIEWED_CARS_LIST:
      return {
        ...state,
        recentViewedCars: action.payload,
      };
    case UPDATE_USER_PROFILE:
      return {
        ...state,
        userPforile: action.payload,
      };
    case GETTING_USER_PROFILE:
      return {
        ...state,
        userProfileData: action.payload,
      };
    case GETTING_USER_CAR_DETAILS:
      return {
        ...state,
        carDetail: action.payload,
      };
    case USER_GARAGE_AZ_FILTER:
      return {
        ...state,
        userGarageA2Z: action.payload,
      };
    case USER_GARAGE_ZA_FILTER:
      return {
        ...state,
        userGarageZ2A: action.payload,
      };
    case FILTER_GARAGE_LIST_WITH_CATEGORY:
      return {
        ...state,
        filteredGarageList: action.payload,
      };
    case USER_SPARE_PARTS_AZ_FILTER:
      return {
        ...state,
        sparePartsA2Z: action.payload,
      };
    case USER_SPARE_PARTS_ZA_FILTER:
      return {
        ...state,
        sparePartsZ2A: action.payload,
      };
    case FILTER_SPARE_PARTS_WITH_CATEGORY:
      return {
        ...state,
        filteredCatList: action.payload,
      };
    default:
      return state;
  }
};

export default homeReducer;
